import ActionsConvocation from './ActionsConvocation';
import ListeChronologique from './ListeChronologique';
import { useState, useEffect } from 'react';
import Voitures from './Voitures';
import {
  getEntrainements, getEntrainement, createEntrainement, deleteEntrainement, setPresenceEnt,
  getRencontres, getRencontre, createRencontre, deleteRencontre, setPresenceRenc,
  getJoueurs, getGymnases, createGymnase, updateGymnase, deleteGymnase, hasRole
} from '../api';

export default function PresencesPage() {
  const [tab, setTab] = useState('entrainements');
  const [entrainements, setEntrainements] = useState([]);
  const [rencontres, setRencontres]       = useState([]);
  const [joueurs, setJoueurs]             = useState([]);
  const [gymnases, setGymnases]           = useState([]);
  const [newGym, setNewGym]               = useState('');
  const [selEnt, setSelEnt]               = useState(null);
  const [selRenc, setSelRenc]             = useState(null);
  const [showNew, setShowNew]             = useState(false);
  const [form, setForm]                   = useState({});
  const [selJoueurs, setSelJoueurs]       = useState([]);
  const [toast, setToast]                 = useState(null);
  const isAdmin = hasRole('coach');

  useEffect(() => { load(); }, []);
  async function load() {
    const [e, r, j, g] = await Promise.all([getEntrainements(), getRencontres(), getJoueurs(), getGymnases()]);
    setEntrainements(e); setRencontres(r); setJoueurs(j.filter(x => x.actif)); setGymnases(g);
  }
  function showToast(msg, type='success') { setToast({msg,type}); setTimeout(()=>setToast(null),2500); }

  async function openEnt(id)  { setSelEnt(await getEntrainement(id)); }
  async function openRenc(id) { setSelRenc(await getRencontre(id)); }

  function openNew() {
    const def = gymnases.find(g => g.par_defaut);
    setForm(tab === 'entrainements' && def ? { lieu: def.nom } : {});
    setSelJoueurs(joueurs.map(j => j.id));
    setShowNew(true);
  }

  async function ajouterGym(e) {
    e.preventDefault();
    if (!newGym.trim()) return;
    try {
      await createGymnase({ nom: newGym, par_defaut: gymnases.length === 0 });
      setNewGym(''); showToast('Gymnase ajouté'); load();
    } catch(err) { showToast(err.message, 'error'); }
  }

  async function setDefaut(g) {
    await updateGymnase(g.id, { par_defaut: 1 });
    showToast(`${g.nom} : gymnase par défaut de cette équipe`); load();
  }

  async function supprimerGym(g) {
    if (!window.confirm(`Retirer ${g.nom} de la liste ?`)) return;
    await deleteGymnase(g.id); showToast('Gymnase retiré'); load();
  }

  async function submitNew(e) {
    e.preventDefault();
    if (!selJoueurs.length) return showToast('Sélectionne au moins un joueur', 'error');
    try {
      const payload = { ...form, joueurs: selJoueurs };
      if (tab === 'entrainements') { await createEntrainement(payload); showToast('Entraînement créé'); }
      else { await createRencontre(payload); showToast('Rencontre créée'); }
      setShowNew(false); setForm({}); setSelJoueurs([]); load();
    } catch(err) { showToast(err.message, 'error'); }
  }

  async function remove(id) {
    if (!window.confirm('Supprimer ?')) return;
    if (tab === 'entrainements') { await deleteEntrainement(id); setSelEnt(null); }
    else { await deleteRencontre(id); setSelRenc(null); }
    showToast('Supprimé'); load();
  }

  async function toggleEnt(entId, joueurId, field, cur) {
    const u = { convoque: cur.convoque, present: cur.present, excuse: cur.excuse };
    u[field] = cur[field] ? 0 : 1;
    if (field === 'present' && u.present) u.excuse = 0;
    if (field === 'excuse'  && u.excuse)  u.present = 0;
    await setPresenceEnt(entId, joueurId, u);
    openEnt(entId);
  }
  async function toggleRenc(rencId, joueurId, field, cur) {
    const u = { convoque: cur.convoque, present: cur.present, excuse: cur.excuse };
    u[field] = cur[field] ? 0 : 1;
    if (field === 'present' && u.present) u.excuse = 0;
    if (field === 'excuse'  && u.excuse)  u.present = 0;
    await setPresenceRenc(rencId, joueurId, u);
    openRenc(rencId);
  }

  const allSelected = selJoueurs.length === joueurs.length && joueurs.length > 0;

  const JoueurPicker = () => (
    <div className="form-group">
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
        <label style={{ margin:0 }}>Joueurs convoqués ({selJoueurs.length})</label>
        <button type="button" onClick={() => setSelJoueurs(allSelected ? [] : joueurs.map(j=>j.id))}
          style={{ background:'none', border:'none', color:'var(--accent)', cursor:'pointer', fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:1 }}>
          {allSelected ? 'Tout décocher' : 'Tout cocher'}
        </button>
      </div>
      <div style={{ display:'flex', flexWrap:'wrap', gap:6, maxHeight:180, overflowY:'auto', padding:4 }}>
        {joueurs.map(j => {
          const on = selJoueurs.includes(j.id);
          return (
            <button key={j.id} type="button"
              onClick={() => setSelJoueurs(p => on ? p.filter(x=>x!==j.id) : [...p, j.id])}
              style={{
                padding:'7px 11px', borderRadius:8, cursor:'pointer', fontSize:12, fontWeight:600,
                border:`1px solid ${on ? 'var(--accent)' : 'rgba(255,255,255,0.08)'}`,
                background: on ? 'rgba(var(--accent-rgb),0.12)' : '#161b22',
                color: on ? 'var(--accent)' : '#8b949e', transition:'all 0.15s'
              }}>
              {on ? '✓ ' : ''}{j.prenom} {j.nom}
            </button>
          );
        })}
      </div>
      {joueurs.length === 0 && <div style={{ fontSize:12, color:'#8b949e' }}>Aucun joueur — ajoute-les dans Équipe.</div>}
    </div>
  );

  const pill = (txt, col, plein = true) => (
    <span style={{ fontSize:10, color:col,
      border:`1px solid ${col}59`,
      background: plein ? `${col}1f` : 'transparent',
      borderRadius:6, padding:'3px 8px', fontWeight: plein ? 700 : 500 }}>{txt}</span>
  );

  const StatusPill = ({ p }) => {
    // Le joueur a répondu lui-même
    if (p.repondu) return p.present ? pill('Présent', '#22c55e') : pill('Absent', '#eab308');
    // Noté par le coach, sans réponse du joueur
    if (p.present) return pill('Présent · noté', '#22c55e', false);
    if (p.excuse)  return pill('Absent · noté',  '#eab308', false);
    return pill('En attente', '#8b949e', false);
  };

  return (
    <>
      <div className="page-header">
        <div className="eyebrow">Gestion équipe</div>
        <h1>📋 Présences</h1>
      </div>

      <div className="tabs">
        {[['entrainements','🏃 Entraînements'],['rencontres','⚽ Rencontres'],
          ...(isAdmin ? [['gymnases','🏟️ Gymnases']] : [])].map(([k,l]) => (
          <button key={k} className={`tab-btn ${tab===k?'active':''}`}
            onClick={() => { setTab(k); setSelEnt(null); setSelRenc(null); setShowNew(false); }}>{l}</button>
        ))}
      </div>

      <div className="section">
        {/* LISTE ENTRAÎNEMENTS */}
        {tab === 'entrainements' && !selEnt && (
          <>
            {isAdmin && <button className="btn btn-primary" style={{ marginBottom:14 }} onClick={openNew}>+ Nouvel entraînement</button>}
            {isAdmin && showNew && (
              <div className="card" style={{ marginBottom:14 }}>
                <form onSubmit={submitNew}>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                    <div className="form-group" style={{ margin:0 }}><label>Date</label>
                      <input type="date" value={form.date||''} onChange={e=>setForm({...form,date:e.target.value})} required /></div>
                    <div className="form-group" style={{ margin:0 }}><label>Heure</label>
                      <input type="time" value={form.heure||''} onChange={e=>setForm({...form,heure:e.target.value})} /></div>
                  </div>
                  <div className="form-group" style={{ marginTop:10 }}><label>Gymnase</label>
                    {gymnases.length > 0 ? (
                      <select value={form.lieu||''} onChange={e=>setForm({...form,lieu:e.target.value})}>
                        <option value="">— Choisir —</option>
                        {gymnases.map(g => (
                          <option key={g.id} value={g.nom}>{g.nom}{g.par_defaut ? ' ★' : ''}</option>
                        ))}
                      </select>
                    ) : (
                      <>
                        <input type="text" value={form.lieu||''} onChange={e=>setForm({...form,lieu:e.target.value})} placeholder="Gymnase" />
                        <div style={{ fontSize:11, color:'#8b949e', marginTop:5 }}>
                          Ajoute tes gymnases dans l'onglet Gymnases pour les retrouver ici.
                        </div>
                      </>
                    )}
                  </div>
                  <div className="form-group"><label>Thème</label>
                    <input type="text" value={form.theme||''} onChange={e=>setForm({...form,theme:e.target.value})} placeholder="Défense, attaque…" /></div>
                  <JoueurPicker />
                  <div style={{ display:'flex', gap:10 }}>
                    <button type="submit" className="btn btn-primary">Créer et convoquer</button>
                    <button type="button" className="btn btn-secondary" onClick={()=>setShowNew(false)}>Annuler</button>
                  </div>
                </form>
              </div>
            )}
            {<ListeChronologique elements={entrainements} vide="Aucun entraînement" rendre={e => (
              <div key={e.id} className="card card-row" style={{ cursor:'pointer' }} onClick={()=>openEnt(e.id)}>
                <div>
                  <div className="card-meta">{e.date}{e.heure && ` · ${e.heure}`}</div>
                  <div className="card-title">{e.theme || 'Entraînement'}</div>
                  {e.lieu && <div className="card-meta" style={{ marginTop:2 }}>📍 {e.lieu}</div>}
                </div>
                <span style={{ color:'var(--accent)', fontSize:20 }}>›</span>
              </div>
)} />}
          </>
        )}

        {/* DÉTAIL ENTRAÎNEMENT */}
        {tab === 'entrainements' && selEnt && (
          <>
            <button onClick={()=>setSelEnt(null)} style={{ background:'none', border:'none', color:'var(--accent)', cursor:'pointer', fontWeight:700, marginBottom:12, fontSize:13 }}>← Retour</button>
            <div className="card" style={{ marginBottom:12 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                <div>
                  <div style={{ fontFamily:'Barlow Condensed', fontSize:20, fontWeight:800 }}>{selEnt.date}{selEnt.heure && ` · ${selEnt.heure}`}</div>
                  <div style={{ color:'#8b949e', fontSize:12 }}>{selEnt.lieu}{selEnt.theme && ` · ${selEnt.theme}`}</div>
                </div>
                {isAdmin && <button className="btn btn-danger" style={{ width:'auto', padding:'6px 12px', fontSize:11 }} onClick={()=>remove(selEnt.id)}>🗑️</button>}
              </div>
              <div style={{ marginTop:10, fontSize:13, display:'flex', gap:14, flexWrap:'wrap' }}>
                <span>📩 Convoqués <b>{selEnt.presences.length}</b></span>
                <span>✅ Présents <b style={{ color:'#22c55e' }}>{selEnt.presences.filter(p=>p.present).length}</b></span>
                <span>⏳ Sans réponse <b style={{ color:'#8b949e' }}>{selEnt.presences.filter(p=>!p.repondu).length}</b></span>
              </div>
              <ActionsConvocation type="entrainement" ev={selEnt} peutRelancer={isAdmin} onToast={showToast} />
            </div>
            {selEnt.presences.map(p => (
              <div key={p.id} className="card card-row" style={{ padding:'10px 14px' }}>
                <div className="player-cell">
                  <span className="num-badge">{p.numero||'—'}</span>
                  <div>
                    <div className="player-name">{p.prenom} {p.nom}</div>
                    <div style={{ marginTop:3 }}><StatusPill p={p} /></div>
                  </div>
                </div>
                {isAdmin && (
                  <div style={{ display:'flex', gap:6 }}>
                    <PresBtn active={p.present} color="#22c55e" label="✓" onClick={()=>toggleEnt(selEnt.id,p.joueur_id,'present',p)} />
                    <PresBtn active={p.excuse}  color="#eab308" label="!" onClick={()=>toggleEnt(selEnt.id,p.joueur_id,'excuse',p)} />
                  </div>
                )}
              </div>
            ))}
          </>
        )}

        {/* LISTE RENCONTRES */}
        {tab === 'rencontres' && !selRenc && (
          <>
            {isAdmin && <button className="btn btn-primary" style={{ marginBottom:14 }} onClick={openNew}>+ Nouvelle rencontre</button>}
            {isAdmin && showNew && (
              <div className="card" style={{ marginBottom:14 }}>
                <form onSubmit={submitNew}>
                  <div className="form-group" style={{ marginBottom:10 }}><label>Date</label>
                    <input type="date" value={form.date||''} onChange={e=>setForm({...form,date:e.target.value})} required /></div>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                    <div className="form-group" style={{ margin:0 }}><label>⏰ RDV sur place</label>
                      <input type="time" value={form.heure_rdv||''} onChange={e=>setForm({...form,heure_rdv:e.target.value})} /></div>
                    <div className="form-group" style={{ margin:0 }}><label>🤾 Coup d'envoi</label>
                      <input type="time" value={form.heure||''} onChange={e=>setForm({...form,heure:e.target.value})} /></div>
                  </div>
                  <div className="form-group" style={{ marginTop:10 }}><label>Adversaire</label>
                    <input type="text" value={form.adversaire||''} onChange={e=>setForm({...form,adversaire:e.target.value})} placeholder="A Epernon 2" required /></div>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                    <div className="form-group" style={{ margin:0 }}><label>Lieu</label>
                      <input type="text" value={form.lieu||''} onChange={e=>setForm({...form,lieu:e.target.value})} placeholder="Gymnase" /></div>
                    <div className="form-group" style={{ margin:0 }}><label>Dom / Ext</label>
                      <select value={form.dom_ext||'Domicile'} onChange={e=>setForm({...form,dom_ext:e.target.value})}>
                        <option>Domicile</option><option>Extérieur</option>
                      </select></div>
                  </div>
                  <JoueurPicker />
                  <div style={{ display:'flex', gap:10 }}>
                    <button type="submit" className="btn btn-primary">Créer et convoquer</button>
                    <button type="button" className="btn btn-secondary" onClick={()=>setShowNew(false)}>Annuler</button>
                  </div>
                </form>
              </div>
            )}
            {<ListeChronologique elements={rencontres} vide="Aucune rencontre" rendre={r => (
              <div key={r.id} className="card card-row" style={{ cursor:'pointer' }} onClick={()=>openRenc(r.id)}>
                <div>
                  <div className="card-meta">
                    {r.date} · {r.dom_ext}
                    {r.heure_rdv && <span style={{ color:'#eab308' }}> · RDV {r.heure_rdv}</span>}
                    {r.heure && <span> · match {r.heure}</span>}
                  </div>
                  <div className="card-title">vs {r.adversaire}</div>
                  {r.lieu && <div className="card-meta" style={{ marginTop:2 }}>📍 {r.lieu}</div>}
                </div>
                <span style={{ color:'var(--accent)', fontSize:20 }}>›</span>
              </div>
)} />}
          </>
        )}

        {/* DÉTAIL RENCONTRE */}
        {tab === 'rencontres' && selRenc && (
          <>
            <button onClick={()=>setSelRenc(null)} style={{ background:'none', border:'none', color:'var(--accent)', cursor:'pointer', fontWeight:700, marginBottom:12, fontSize:13 }}>← Retour</button>
            <div className="card" style={{ marginBottom:12 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                <div>
                  <div style={{ fontFamily:'Barlow Condensed', fontSize:20, fontWeight:800 }}>vs {selRenc.adversaire}</div>
                  <div style={{ color:'#8b949e', fontSize:12 }}>{selRenc.date} · {selRenc.dom_ext}</div>
                  <div style={{ fontSize:12, marginTop:3, display:'flex', gap:12, flexWrap:'wrap' }}>
                    {selRenc.heure_rdv && <span style={{ color:'#eab308', fontWeight:700 }}>⏰ RDV {selRenc.heure_rdv}</span>}
                    {selRenc.heure && <span style={{ color:'#8b949e' }}>🤾 Coup d'envoi {selRenc.heure}</span>}
                  </div>
                  {selRenc.lieu && <div style={{ color:'#8b949e', fontSize:12 }}>📍 {selRenc.lieu}</div>}
                </div>
                {isAdmin && <button className="btn btn-danger" style={{ width:'auto', padding:'6px 12px', fontSize:11 }} onClick={()=>remove(selRenc.id)}>🗑️</button>}
              </div>
              <div style={{ marginTop:10, fontSize:13, display:'flex', gap:14, flexWrap:'wrap' }}>
                <span>📩 Convoqués <b>{selRenc.presences.length}</b></span>
                <span>✅ Présents <b style={{ color:'#22c55e' }}>{selRenc.presences.filter(p=>p.present).length}</b></span>
                <span>⏳ Sans réponse <b style={{ color:'#8b949e' }}>{selRenc.presences.filter(p=>!p.repondu).length}</b></span>
              </div>
              <ActionsConvocation type="rencontre" ev={selRenc} peutRelancer={isAdmin} onToast={showToast} />
            </div>

            {/* Récap covoiturage — matchs à l'extérieur */}
            {selRenc.dom_ext === 'Extérieur' && (() => {
              const presents  = selRenc.presences.filter(p => p.present);
              const repondus  = presents.filter(p => p.repondu);
              const aPreciser = presents.filter(p => !p.repondu);
              const auneau    = repondus.filter(p => p.depart_auneau);
              const direct    = repondus.filter(p => !p.depart_auneau);
              const chauffeurs = auneau.filter(p => (p.places||0) > 0);
              const places    = chauffeurs.reduce((s,p) => s + (p.places||0), 0);
              const aPlacer   = auneau.filter(p => (p.places||0) === 0).length;
              const manque    = aPlacer - places;

              return (
                <div className="card" style={{ marginBottom:12,
                  borderColor: manque > 0 ? 'rgba(239,68,68,0.35)' : 'rgba(59,130,246,0.3)',
                  background: manque > 0 ? 'rgba(239,68,68,0.05)' : 'rgba(59,130,246,0.05)' }}>
                  <div style={{ fontSize:10, fontWeight:700, letterSpacing:2, textTransform:'uppercase',
                    color: manque > 0 ? '#ef4444' : '#3b82f6', marginBottom:10 }}>
                    🚗 Covoiturage
                  </div>

                  <div style={{ display:'flex', gap:8, marginBottom:12, flexWrap:'wrap' }}>
                    {[['Partent du club', auneau.length, '#e6edf3'],
                      ['Places offertes', places, '#22c55e'],
                      ['À placer', aPlacer, aPlacer > 0 ? '#eab308' : '#8b949e'],
                      ['Direct au match', direct.length, '#8b949e'],
                      ...(aPreciser.length ? [['À préciser', aPreciser.length, '#6b7280']] : [])
                     ].map(([l,v,col]) => (
                      <div key={l} style={{ flex:'1 1 70px', background:'#0d1117', borderRadius:8,
                        padding:'9px 6px', textAlign:'center' }}>
                        <div style={{ fontFamily:'Barlow Condensed', fontSize:20, fontWeight:800, color:col }}>{v}</div>
                        <div style={{ fontSize:9, color:'#8b949e', letterSpacing:0.5, textTransform:'uppercase', marginTop:2 }}>{l}</div>
                      </div>
                    ))}
                  </div>

                  {manque > 0 && (
                    <div style={{ fontSize:12, color:'#ef4444', fontWeight:600, marginBottom:10 }}>
                      ⚠️ Il manque {manque} place{manque>1?'s':''}
                    </div>
                  )}

                  {/* Qui monte avec qui : le coach place et déplace les passagers */}
                  <div style={{ marginBottom: aPreciser.length ? 10 : 0 }}>
                    <Voitures rencontreId={selRenc.id} mode="coach" onToast={showToast}
                              cle={JSON.stringify((selRenc.presences || []).map(p => [p.joueur_id, p.present, p.depart_auneau, p.places]))} />
                  </div>

                  {aPreciser.length > 0 && (
                    <div>
                      <div style={{ fontSize:10, color:'#8b949e', letterSpacing:1, textTransform:'uppercase', marginBottom:5 }}>
                        Trajet à préciser
                      </div>
                      <div style={{ fontSize:12.5, color:'#6b7280', lineHeight:1.6 }}>
                        {aPreciser.map(p => `${p.prenom} ${p.nom}`).join(' · ')}
                      </div>
                      <div style={{ fontSize:10.5, color:'#6b7280', marginTop:3, fontStyle:'italic' }}>
                        Notés présents par le coach, ils n'ont pas indiqué leur trajet.
                      </div>
                    </div>
                  )}

                  {presents.length === 0 && (
                    <div style={{ fontSize:12, color:'#8b949e' }}>
                      Personne n'a encore confirmé sa présence.
                    </div>
                  )}
                </div>
              );
            })()}

            {selRenc.presences.map(p => (
              <div key={p.id} className="card card-row" style={{ padding:'10px 14px' }}>
                <div className="player-cell">
                  <span className="num-badge">{p.numero||'—'}</span>
                  <div>
                    <div className="player-name">{p.prenom} {p.nom}</div>
                    <div style={{ marginTop:3, display:'flex', gap:6, alignItems:'center', flexWrap:'wrap' }}>
                      <StatusPill p={p} />
                      {selRenc.dom_ext === 'Extérieur' && p.present === 1 && (
                        !p.repondu ? (
                          <span style={{ fontSize:10, color:'#6b7280', border:'1px dashed rgba(255,255,255,0.12)',
                            borderRadius:6, padding:'2px 7px' }}>🚗 trajet non renseigné</span>
                        ) : p.depart_auneau ? (
                          <span style={{ fontSize:10, color: (p.places||0) > 0 ? '#22c55e' : '#eab308',
                            border:`1px solid ${(p.places||0) > 0 ? 'rgba(34,197,94,0.35)' : 'rgba(234,179,8,0.35)'}`,
                            borderRadius:6, padding:'2px 7px' }}>
                            {(p.places||0) > 0 ? `🚗 ${p.places} place${p.places>1?'s':''}` : '🚶 cherche une place'}
                          </span>
                        ) : (
                          <span style={{ fontSize:10, color:'#8b949e', border:'1px solid rgba(255,255,255,0.1)',
                            borderRadius:6, padding:'2px 7px' }}>📍 direct au match</span>
                        )
                      )}
                    </div>
                  </div>
                </div>
                {isAdmin && (
                  <div style={{ display:'flex', gap:6 }}>
                    <PresBtn active={p.present} color="#22c55e" label="✓" onClick={()=>toggleRenc(selRenc.id,p.joueur_id,'present',p)} />
                    <PresBtn active={p.excuse}  color="#eab308" label="!" onClick={()=>toggleRenc(selRenc.id,p.joueur_id,'excuse',p)} />
                  </div>
                )}
              </div>
            ))}
          </>
        )}
        {isAdmin && tab === 'gymnases' && (
          <>
            <div style={{ fontSize:12.5, color:'var(--muted)', lineHeight:1.5, marginBottom:12 }}>
              La liste des gymnases est commune à tout le club. Le gymnase ★ par défaut, proposé pour les nouveaux entraînements, est propre à cette équipe.
            </div>
            <form onSubmit={ajouterGym} style={{ marginBottom:16 }}>
              <div className="form-group" style={{ marginBottom:10 }}>
                <label>Nouveau gymnase</label>
                <div style={{ display:'flex', gap:8 }}>
                  <input type="text" value={newGym} onChange={e=>setNewGym(e.target.value)}
                    placeholder="Ex : Gymnase des Sablons" />
                  <button type="submit" className="btn btn-primary" style={{ width:'auto', padding:'0 18px', whiteSpace:'nowrap' }}>Ajouter</button>
                </div>
              </div>
            </form>

            {gymnases.length === 0 && (
              <div className="card" style={{ textAlign:'center', color:'#8b949e', padding:'26px 16px' }}>
                Aucun gymnase enregistré.<br/>
                <span style={{ fontSize:12 }}>Ajoute les salles où vous vous entraînez.</span>
              </div>
            )}

            {gymnases.map(g => (
              <div className="card card-row" key={g.id} style={{ padding:'12px 14px' }}>
                <div style={{ display:'flex', alignItems:'center', gap:9 }}>
                  <span style={{ fontSize:16 }}>🏟️</span>
                  <div>
                    <div style={{ fontSize:14, fontWeight:700 }}>{g.nom}</div>
                    {g.par_defaut === 1 && (
                      <div style={{ fontSize:10, color:'#eab308', fontWeight:700, letterSpacing:1, marginTop:2 }}>
                        ★ PAR DÉFAUT POUR CETTE ÉQUIPE
                      </div>
                    )}
                  </div>
                </div>
                <div style={{ display:'flex', gap:6 }}>
                  {!g.par_defaut && (
                    <button className="btn btn-secondary" style={{ width:'auto', padding:'7px 11px', fontSize:11 }}
                      onClick={()=>setDefaut(g)}>★ Par défaut</button>
                  )}
                  <button className="btn btn-danger" style={{ width:'auto', padding:'7px 11px', fontSize:11 }}
                    onClick={()=>supprimerGym(g)}>🗑️</button>
                </div>
              </div>
            ))}

            {gymnases.length > 0 && (
              <div style={{ fontSize:11, color:'#8b949e', marginTop:12, lineHeight:1.6 }}>
                Le gymnase marqué ★ est proposé automatiquement à la création d'un entraînement.
              </div>
            )}
          </>
        )}
      </div>
      {toast && <div className={`toast ${toast.type}`}>{toast.msg}</div>}
    </>
  );
}

function PresBtn({ active, color, label, onClick }) {
  return (
    <button onClick={onClick} style={{
      width:34, height:34, borderRadius:8, cursor:'pointer',
      border: `1px solid ${active ? color : 'rgba(255,255,255,0.08)'}`,
      background: active ? color+'22' : 'transparent',
      color: active ? color : '#8b949e',
      fontSize:14, fontWeight:800, transition:'all 0.15s'
    }}>{label}</button>
  );
}
